package com.exura.features.publicplans.domain.usecase

import com.exura.features.publicplans.domain.PublicPlansConstants
import com.exura.features.publicplans.domain.api.DisablePublicPlanSharingRequest
import com.exura.features.publicplans.domain.api.DisablePublicPlanSharingResponse
import com.exura.features.publicplans.domain.repository.ProviderPublicPlanRepository
import dev.gitlive.firebase.functions.FirebaseFunctions

class DisablePublicPlanSharingUseCase(
    private val functions: FirebaseFunctions,
    private val repository: ProviderPublicPlanRepository,
) {
    suspend operator fun invoke(publicPlanId: String): Result<Boolean> = runCatching {
        val publicEntry = repository.read(publicPlanId).getOrThrow()
        val callable = functions.httpsCallable(PublicPlansConstants.Functions.GLOBAL_DISABLE_PUBLIC_PLAN_SHARING)

        val response = callable.invoke(
            DisablePublicPlanSharingRequest(globalEntryId = publicEntry.globalEntryId)
        )
        val result = response.data<DisablePublicPlanSharingResponse>()

        if (result.success) {
            repository.disableSharing(publicPlanId).getOrThrow()
            true
        } else {
            throw Exception(result.message ?: "Failed to enable plan public")
        }

    }
}
